module.exports = __webpack_public_path__ + "img/form_default.bbc2c449.svg";